module.exports = __webpack_public_path__ + "static/media/logo-pluralis.6032fb91.jpg";